import { Box, Tabs } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { useTabQueryParam } from "../../hooks/useTabQueryParam"
import { StandardTab } from "../tab/StandardTab"
import { TabPanel } from "./tabPanel"

const useStyles = makeStyles()((theme) => ({
    content: {
        width: "100%",
    },
    tab: {
        fontWeight: 500,
        fontSize: "0.875rem",
        color: theme.palette.text.secondary,
        backgroundColor: "transparent",
        borderRadius: "2.25rem",
        minHeight: 36,
        minWidth: "auto",
        padding: theme.spacing(0, 2),
        marginRight: theme.spacing(1),
    },
    selectedTab: {
        color: `${theme.palette.common.white} !important`,
        backgroundColor: theme.palette.tailwind.slate[900],
        "&:hover": {
            backgroundColor: theme.palette.tailwind.slate[700],
        },
    },
}))
type TabConfig = {
    label: string // Label for the tab button
    component: JSX.Element // React component to render when the tab is selected
}

// Props for the StandardTabs component
type StandardTabsProps = {
    tabs: TabConfig[] // Array of tab configurations
    defaultTab?: number // Optional default tab index
    ignoreRender?: boolean
    onTabChange?: (newTabIndex: number) => void
}

export const StandardTabs = ({ tabs, ignoreRender, onTabChange, defaultTab = 0 }: StandardTabsProps) => {
    const { classes, cx } = useStyles()
    const [value, handleChangeTab] = useTabQueryParam()

    return (
        <Box className={classes.content}>
            <Box>
                <Tabs
                    value={ignoreRender ? undefined : value}
                    onChange={(_, newValue) => {
                        onTabChange?.(newValue)
                        handleChangeTab(newValue)
                    }}
                    TabIndicatorProps={{ style: { display: "none" } }}
                >
                    {tabs.map((tab, index) => (
                        <StandardTab
                            className={cx(classes.tab, {
                                [classes.selectedTab]: value === index && !ignoreRender,
                            })}
                            key={index}
                            label={tab.label}
                            disableRipple
                        />
                    ))}
                </Tabs>
            </Box>
            {!ignoreRender &&
                tabs.map(
                    (tab, index) =>
                        value === index && (
                            <TabPanel key={index} value={value} index={index}>
                                {tab.component}
                            </TabPanel>
                        ),
                )}
        </Box>
    )
}
